export default "__VITE_ASSET__PMOFXkU4__"